import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FilterService } from 'libs/portal/src/services/filter/filter.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-merchants-filter',
  templateUrl: './merchants-filter.component.html',
  styleUrls: ['./merchants-filter.component.scss'],
})
export class MerchantsFilterComponent implements OnInit, OnDestroy {
  constructor(private filterService: FilterService) {}

  form = new UntypedFormGroup({
    merchantControl: new UntypedFormControl('', [Validators.required]),
  });

  sub: Subscription;

  filter() {
    const filterObj = {
      status: null,
      bundle: null,
      merchants: this.form.get('merchantControl')?.value,
      terminal: null,
      lastUpdate: null,
    };
    this.filterService.emit(filterObj);
  }

  ngOnInit() {
    this.sub = this.filterService.searchClickedEvent.subscribe((clicked) => {
      if (clicked) {
        this.filter();
      }
    });
  }

  ngOnDestroy(): void {
      this.sub?.unsubscribe();
  }
}
